import React from 'react';
import Hero from '@components/Hero';
import Streamfields from '@streamfields/Streamfields';
import { Streamfield, WagtailImage } from '@/types';
import BannerImage from '@components/BannerImage';
import FakeSearch, { FakeSearchProps } from '@components/Fakesearch';
import { basePageWrap, BasePageProps } from '../BasePage';

type Props = {
  title: string;
  subtitle?: string;
  banner_image?: WagtailImage;
  content: Streamfield[];
  subheader: string | null;
  fakesearch_data: FakeSearchProps;
} & BasePageProps;

function STWWHomePage(props: Props) {
  const {
    title = '',
    subtitle,
    banner_image: bannerImage,
    subheader,
    fakesearch_data: fakesearchData,
    content,
  } = props;

  return (
    <div className='home-page'>
      {bannerImage ? <BannerImage image={bannerImage} /> : null}
      <Hero title={title} subtitle={subheader} text={subtitle} />
      {fakesearchData ? <FakeSearch {...fakesearchData} /> : null}
      {content ? <Streamfields fields={content} /> : null}
    </div>
  );
}

export default basePageWrap<Props>(STWWHomePage);
